import { render, staticRenderFns } from "./searchFor.vue?vue&type=template&id=65b6be03&scoped=true"
import script from "./searchFor.vue?vue&type=script&lang=js"
export * from "./searchFor.vue?vue&type=script&lang=js"
import style0 from "./searchFor.vue?vue&type=style&index=0&id=65b6be03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b6be03",
  null
  
)

export default component.exports